/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import EventBox from '../partials/EventBox';
import Image from '../partials/Image';

import styles from '../../../styles/slides/event.module.scss';

const propTypes = {
    item: PropTypes.shape({
        event: AppPropTypes.event,
    }),
    className: PropTypes.string,
    isDragging: PropTypes.bool,
    isCurrent: PropTypes.bool,
};

const defaultProps = {
    item: null,
    className: null,
    isDragging: false,
    isCurrent: false,
};

const EventSlide = ({ item, className, isDragging, isCurrent }) => {
    const { event = null } = item || {};
    const { image = null } = event || {};
    const { url: imageUrl = null } = image || {};
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isCurrent]: isCurrent,
                    [styles.isDragging]: isDragging,
                    [styles.hasImage]: imageUrl !== null,
                },
            ])}
        >
            <div className={styles.inner}>
                <div className={styles.content}>
                    <EventBox item={event} tabIndex={!isCurrent ? '-1' : null} withButton />
                </div>
            </div>
            {imageUrl !== null ? (
                <div className={styles.visual}>
                    <Image
                        className={styles.imageWrap}
                        imageClassName={styles.image}
                        media={image}
                        cover
                        fit
                    />
                </div>
            ) : null}
        </div>
    );
};

EventSlide.propTypes = propTypes;
EventSlide.defaultProps = defaultProps;

export default EventSlide;
